import React from "react";
import { NakiNigunManageSelectedItemsTemplate } from "themes/application/naki-nigun/components";

function NakiNigunManageSelectedItems(props) {
    return <NakiNigunManageSelectedItemsTemplate {...props} />;
}

export default NakiNigunManageSelectedItems;
